import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').replace(/\/$/, '');
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or Anon Key not set. Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY env vars.');
} else if (process.env.NODE_ENV === 'development') {
  try {
    const payload = JSON.parse(atob(supabaseAnonKey.split('.')[1]));
    const ref = payload?.ref;
    const host = new URL(supabaseUrl).hostname.replace('.supabase.co', '');
    if (ref && host && ref !== host) {
      console.warn(
        `[supabase] URL host "${host}" does not match anon key project ref "${ref}". This usually causes "Failed to fetch". Use the Project URL from the same project as the anon key (Dashboard → Settings → API).`,
      );
    }
  } catch {
    /* ignore */
  }
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

export function getRedirectUrl(slug) {
  return `${supabaseUrl}/functions/v1/redirect/${slug}`;
}
